<template>
  <div class="page comparator-home d-flex flex-column flex-grow-1">
    <template v-if="!melted">
      <ComparatorHeader />
      <div
        v-if="rg && rg.status === 'VALIDATED'"
        class="w-100 bg-success d-flex justify-content-center fs-2x text-white py-10 fw-bolder"
      >
        Cette cotation a déjà été payée
      </div>
      <div
        v-if="notFound"
        class="d-flex flex-column justify-content-center align-items-center"
      >
        <video
          autoplay="autoplay"
          loop="loop"
          muted="muted"
          playsinline
          src="../../../assets/media/videos/phone.mp4"
          style="width: 300px"
          type="video/mp4"
        ></video>

        <h1 class="mt-10">Désolé cette cotation n'existe plus chez nous</h1>
        <p class="text-center fs-2">
          Elle a peut-être déjà été soldée ou annulée
          <br />
          Contactez notre service client pour plus d'informations
        </p>
        <div class="d-flex mt-5 align-items-center">
          <router-link
            :to="{ name: 'comparateur-index' }"
            class="btn btn-primary ms-5"
          >
            <i class="fad fa-file-contract"></i>
            Souscrire à un nouveau contrat
          </router-link>
        </div>
      </div>
    </template>

    <template v-if="!notFound && rg && form">
      <div v-if="!melted" class="row px-2 py-5 mx-auto w-100">
        <transition appear name="slide-left">
          <h1 v-if="form" class="text-green fw-bolder" style="font-size: 2em">
            {{ trans("Ma cotation") }} {{ form.label }}
          </h1>
        </transition>
      </div>

      <!--        <input class="form-control" style="width: 300px" type="number" v-model="progress">-->
      <div
        class="row flex-column mx-auto flex-grow-1 w-100 d-flex align-items-start"
      >
        <div
          v-if="!melted"
          class="d-flex justify-content-center position-relative mt-2"
        >
          <span
            :key="'progress_' + progress"
            class="progress-percent me-2 fw-bolder fs-2"
            >{{ progress }}%</span
          >
          <transition appear name="max-width">
            <div
              ref="progress"
              class="progress position-relative w-100 rounded"
            >
              <div
                :key="'progress_in_' + progress"
                :style="{ width: progress + '%' }"
                class="rounded determinate"
              ></div>
            </div>
          </transition>
        </div>

        <template v-if="isManager()">
          <template v-for="(step, stepIndex) in form.steps">
            <template v-if="step.isVisible()">
              <div
                v-for="(section, sectionIndex) in step.sections"
                :key="
                  'step_' +
                  stepIndex +
                  '_section_' +
                  (section.uuid || sectionIndex)
                "
                class="my-3 px-0"
              >
                <template v-if="section.isVisible()">
                  <h2 v-if="!helper.empty(section.label)" class="my-5">
                    {{ section.label }}
                  </h2>

                  <div
                    :class="{
                      'bg-transparent p-0 m-0': isSectionContainSurvey(section),
                    }"
                    class=""
                  >
                    <div
                      :class="{ 'p-0': isSectionContainSurvey(section) }"
                      class="p-0"
                    >
                      <div class="d-flex flex-wrap justify-content-start">
                        <template
                          v-for="(question, qIndex) in section.questions"
                        >
                          <template v-if="question.isVisible()">
                            <transition-group
                              :key="
                                'tg_' +
                                stepIndex +
                                '_' +
                                sectionIndex +
                                '_' +
                                qIndex
                              "
                              :style="{
                                display:
                                  !question.isAuthorized() || question.hidden
                                    ? 'none'
                                    : 'flex',
                              }"
                              appear
                              class="flex-grow-1 question mw-100"
                              name="slide-up"
                              tag="div"
                            >
                              <small :key="'dbg_' + (question.uuid || qIndex)" class="text-muted" style="font-size:10px;position:absolute;top:0;right:5px;z-index:1;opacity:0.7">#{{question.id}}</small>
                              <question-manager
                                :key="'qm_' + (question.uuid || qIndex)"
                                :creatingResponseGroup="creatingResponseGroup"
                                :currentStep="step"
                                :question="question"
                                :reset="reset"
                                :style="{ '--i': qIndex + 1 }"
                                @nextStep="nextStep"
                                v-on:deleteSubResponseGroup="
                                  deleteSubResponseGroup
                                "
                                v-on:previous="previousStep"
                              ></question-manager>
                            </transition-group>
                          </template>
                        </template>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </template>
        </template>
        <template v-else-if="form && currentStepIndex < form.steps.length">
          <template v-for="(step, stepIndex) in form.steps">
            <template v-if="currentStep && step.uuid === currentStep.uuid">
              <div :key="'step_header_' + stepIndex">
                <transition :name="animation" appear mode="out-in">
                  <div
                    v-if="!helper.empty(step.label)"
                    :key="'step_title_' + (step.uuid || stepIndex)"
                    class="fs-2 fw-bolder text-green pt-10 px-5"
                  >
                    <!--                                {{step.id}}-->
                    {{ step.label }}
                  </div>
                </transition>
                <template v-if="!helper.empty(step.description)">
                  <transition :name="animation" appear mode="out-in">
                    <div
                      :key="'step_description_' + (step.uuid || stepIndex)"
                      class="text-gray-400 fs-4 mw-700px px-5"
                      style="transition-delay: 0.2s; text-align: justify"
                    >
                      {{ step.description }}
                    </div>
                  </transition>
                </template>
              </div>
              <div
                v-for="(section, sectionIndex) in currentStep.sections"
                class="w-100 section mt-5"
                :key="
                  'current_section_' +
                  stepIndex +
                  '_' +
                  (section.uuid || sectionIndex)
                "
              >
                <template v-if="section.isVisible()">
                  <h2 v-if="!helper.empty(section.label)" class="my-5">
                    {{ section.label }}
                  </h2>

                  <div
                    :class="{
                      'bg-transparent p-0 m-0': isSectionContainSurvey(section),
                    }"
                    class="card question-container-card w-100"
                  >
                    <div
                      :class="{ 'p-0': isSectionContainSurvey(section) }"
                      class="card-body p-0 w-100"
                    >
                      <div class="d-flex flex-wrap justify-content-start w-100">
                        <template
                          v-for="(question, qIndex) in section.questions"
                        >
                          <template v-if="question.isVisible()">
                            <transition-group
                              :key="'tg_current_' + sectionIndex + '_' + qIndex"
                              :style="{
                                display:
                                  !question.isAuthorized() || question.hidden
                                    ? 'none'
                                    : 'flex',
                              }"
                              appear
                              class="flex-grow-1 question mw-100"
                              name="slide-up"
                              tag="div"
                            >
                              <small :key="'dbg_current_' + (question.uuid || qIndex)" class="text-muted" style="font-size:10px;position:absolute;top:0;right:5px;z-index:1;opacity:0.7">#{{question.id}}</small>
                              <question-manager
                                :key="'qm_current_' + (question.uuid || qIndex)"
                                :creatingResponseGroup="creatingResponseGroup"
                                :currentStep="currentStep"
                                :question="question"
                                :reset="reset"
                                :style="{ '--i': qIndex < 5 ? qIndex + 1 : 5 }"
                                @nextStep="nextStep"
                                v-on:previous="previousStep"
                              ></question-manager>
                            </transition-group>
                          </template>
                        </template>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </template>
        </template>
      </div>

      <!-- <div class="h-100px"></div> -->
      <!-- <div class="row mx-auto w-100" style="position: fixed;bottom: 0px;left: 50%;background: white;transform: translateX(-50%);"> -->
      <div class="row mx-auto w-100">
        <div class="d-flex justify-content-between my-10">
          <div>
            <button
              v-if="showPreviousStep"
              class="btn btn-secondary"
              @click="previousStep"
            >
              <i class="fad fa-arrow-left"></i>
              {{ trans("Etape précédente") }}
            </button>
          </div>

          <div>
            <!-- Bouton "Soumettre" uniquement pour les formulaires de type FORM -->
            <div v-if="!showNextStep && form && form.type === 'FORM'">
              <b-button
                :disabled="!currentStep?.isValid"
                v-b-modal.modal-1
                variant="primary"
              >
                {{ trans("Soumettre le formulaire") }}
              </b-button>

              <!-- Modal pour formulaire de type FORM -->
              <b-modal
                centered
                id="modal-1"
                :title="trans('Formulaire soumis')"
              >
                <div
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <img
                    alt=""
                    class="h-50 w-50"
                    src="../../../assets/booty.png"
                  />

                  <!-- Message personnalisé -->
                  <h4 class="text-center" v-if="form.completionMessage">
                    {{ form.completionMessage }}
                  </h4>

                  <!-- Message par défaut si pas de message personnalisé -->
                  <h4 class="text-center" v-else>
                    {{
                      trans(
                        "Merci ! Votre demande a été enregistrée avec succès. Un agent vous contactera prochainement."
                      )
                    }}
                  </h4>
                </div>

                <template #modal-footer="{}">
                  <router-link :to="{ name: 'comparateur-index' }">
                    <button class="btn btn-primary" type="button">
                      Compris
                    </button>
                  </router-link>
                </template>
              </b-modal>
            </div>
          </div>

          <div>
            <button
              v-if="showNextStep"
              :disabled="!currentStep.isValid"
              class="btn btn-warning"
              @click="nextStep"
            >
              {{ trans("Etape suivante") }}
              <i class="fad fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import ComparatorHeader from "@/views/Comparator/Components/ComparatorHeader.vue";
import ResponseGroup from "@/entity/ResponseGroup";
import Survey from "@/entity/Survey";
import { api } from "@/services/Api";
import { helper } from "@/services/Helper";
import Popup from "@/entity/Popup";
import Step from "@/entity/Step";
import Section from "@/entity/Section";
import Question from "@/entity/Question";
import Response from "@/entity/Response";
import NumberQuestion from "@/views/Income/Comparator/FormComponents/NumberQuestion.vue";
import Money from "@/views/Income/Comparator/FormComponents/Money.vue";
import CarBrand from "@/views/Income/Comparator/FormComponents/CarBrand.vue";
import CarModel from "@/views/Income/Comparator/FormComponents/CarModel.vue";
import TextType from "@/views/Income/Comparator/FormComponents/TextType.vue";
import Checkbox from "@/views/Income/Comparator/FormComponents/Checkbox.vue";
import QuestionList from "@/views/Income/Comparator/FormComponents/QuestionList.vue";
import Contact from "@/views/Income/Comparator/FormComponents/Contact.vue";
import Radio from "@/views/Income/Comparator/FormComponents/Radio.vue";
import Mail from "@/views/Income/Comparator/FormComponents/Mail.vue";
import Date from "@/views/Income/Comparator/FormComponents/Date.vue";
import FileQuestion from "@/views/Income/Comparator/FormComponents/FileQuestion.vue";
import SurveyType from "@/views/Income/Comparator/FormComponents/SurveyType.vue";
import MultipleSurvey from "@/views/Income/Comparator/FormComponents/MultipleSurvey.vue";
import PackCategory from "@/views/Income/Comparator/FormComponents/PackCategory.vue";
import { auth } from "@/services/Auth";
import Branch from "@/entity/Branch";
import Comparison from "@/views/Income/Comparator/FormComponents/Comparison.vue";
import Insurer from "@/entity/Insurer";
import QuestionManager from "@/views/Comparator/Components/QuestionManager.vue";
import store from "@/store";
import { createItemFromType } from "@/services/ItemFunction";
import { prefillService } from "@/services/PrefillService";
import { engineService } from "@/services/calculator/EngineService";

@Component({
  name: "ResponseGroupManager",
  provide() {
    return {
      comparatorContext: () => ({
        rg: (this as any).rg,
        branch: (this as any).branch,
        form: (this as any).form,
      }),
    };
  },
  components: {
    QuestionManager,
    Comparison,
    PackCategory,
    MultipleSurvey,
    SurveyType,
    FileQuestion,
    Date,
    Mail,
    Radio,
    Contact,
    QuestionList,
    Checkbox,
    TextType,
    CarModel,
    CarBrand,
    Money,
    NumberQuestion,
    ComparatorHeader,
  },
})
export default class ResponseGroupManager extends Vue {
  [x: string]: any;

  loading = false;
  @Prop() uuid?: string;
  @Prop({ default: false }) melted!: boolean;
  rgUuid: any = null;
  rg: ResponseGroup | any = null;
  branch: Branch | any = null;
  progress = 0;
  form: Survey | any = null;
  requireAuth = false;
  notFound = false;
  potentialOwners: any[] = [];
  ownerEmail = "";
  currentStep: Step | any = null;
  currentStepIndex = 0;
  isStepValid = false;
  partner: any;
  animation = "slide-left";
  stepAccessGranted = true;
  creatingResponseGroup = false;
  private _validateTimer: any = null;

  get title() {
    return "Comparateur";
  }

  get showPreviousStep() {
    if (this.form.steps.length > 0 && this.currentStepIndex > 0) {
      let hasAuthorizedPreviousStep = false;
      for (const [index, step] of this.form.steps.entries()) {
        if (index < this.currentStepIndex) {
          if (!helper.empty(step.requiredRoles)) {
            let accessGranted = auth.checkRoleTabs(step.requiredRoles);
            if (accessGranted) {
              hasAuthorizedPreviousStep = true;
            }
          } else {
            hasAuthorizedPreviousStep = true;
          }
        }
      }
      return hasAuthorizedPreviousStep;
    }
    return false;
  }

  get showNextStep() {
    if (!this.currentStep) {
      return false;
    }
    if (!this.form) {
      return false;
    }
    if (this.form.steps.length === 1 && this.melted) {
      return false;
    }
    if (this.currentStepIndex === this.form.steps.length - 1) {
      return false;
    }
    let hasAuthorizedNextStep = false;
    for (const [index, step] of this.form.steps.entries()) {
      if (index > this.currentStepIndex) {
        if (!helper.empty(step.requiredRoles)) {
          let accessGranted = auth.checkRoleTabs(step.requiredRoles);
          if (accessGranted) {
            hasAuthorizedNextStep = true;
          }
        } else {
          hasAuthorizedNextStep = true;
        }
      }
    }
    return hasAuthorizedNextStep;
  }

  toggle(text: string) {
  }

  isManager() {
    return auth.hasRole("ROLE_MANAGER") || auth.hasRole("ROLE_PARTNER");
  }

  isPartner() {
    return auth.hasRole("ROLE_PARTNER");
  }

  @Watch("$store.state.mainStore.responseDeletions", { immediate: true })
  removeResponse() {
    let hasDeleted = false;
    const deletions: string[] = JSON.parse(
      JSON.stringify(this.$store.state.mainStore.responseDeletions)
    );
    if (this.rg && this.rg.responses) {
      const deletedUuids: string[] = [];
      for (const uuid of deletions) {
        const idx = this.rg.responses.findIndex(
          (r: Response) => r.uuid === uuid
        );
        if (idx !== -1) {
          this.$delete(this.rg.responses, idx);
          deletedUuids.push(uuid);
          hasDeleted = true;
        }
      }
      if (hasDeleted) {
        const remaining = deletions.filter(
          (u: string) => !deletedUuids.includes(u)
        );
        this.$store.commit("setResponseDeletions", remaining);
        this.linkResponsesToStore();
      }
    }
  }

  async mounted() {
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = (e: any) => {
      window.history.pushState(null, "", window.location.href);
      this.previousStep();
    };
    if (!helper.empty(this.uuid)) {
      this.rgUuid = this.uuid;
    } else if (!helper.empty(this.$route.params.rgUuid)) {
      this.rgUuid = this.$route.params.rgUuid;
    }
    if (helper.empty(this.rgUuid)) {
      const pop = new Popup("Erreur", "Code cotation introuvable");
      this.$router.push({ name: "comparateur-index" });
      return;
    }
    if (this.rgUuid === "new") {
      this.createResponseGroup(this.$route.params.surveySlug);
      return;
    }

    // Utiliser la nouvelle méthode avec ComparatorStore (Option C)
    await this.loadNewData();
  }

  beforeDestroy() {
    engineService.shutdown();
    window["classes" as any] = null as any;
    this.$store.commit("setEngineClasses", []);
  }

  handleBeforeUnload(event: BeforeUnloadEvent) {
    engineService.shutdown();
  }

  async createResponseGroup(surveySlug: string) {
    this.$store.commit("loading");
    if (prefillService.hasPrefillValuesInUrl()) {
      await prefillService.storePrefillData(surveySlug);
    }
    const source = this.$store.state.mainStore.source;
    const affiliation = this.$store.state.mainStore.affiliation;
    const parent = "null";
    const res = await api.get(
      api.form,
      "api/response/group/new/" +
        surveySlug +
        "/" +
        parent +
        "/" +
        source +
        "/" +
        affiliation
    );
    if (res && res.data && res.data.responseGroup) {
      const rg = new ResponseGroup(res.data.responseGroup);
      const cotation = {
        uuid: rg.uuid,
        state: 0,
        createdAt: rg.createdAt,
        lastUpdate: rg.updatedAt,
        branch: rg.branchSlug,
        survey: rg.surveySlug,
      };
      const cotations = localStorage.getItem("cotations")
        ? JSON.parse(localStorage.getItem("cotations")!)
        : [];
      cotations.push(cotation);
      localStorage.setItem("cotations", JSON.stringify(cotations));
      this.$router.push({
        name: "response-group-manager",
        params: {
          surveySlug: surveySlug,
          rgUuid: res.data.responseGroup.uuid,
        },
      });
      window.location.reload();
    }
    this.$store.commit("stopLoading");
  }

  reset() {}

  getStepIndex(step: Step) {
    return this.form.steps.findIndex((s: Step) => s.uuid === step.uuid);
  }

  goToStep(step: Step) {
    if (auth.hasRole("ROLE_MANAGER")) {
      this.currentStepIndex = this.form.steps.findIndex(
        (s: Step) => s.uuid === step.uuid
      );
    }
  }

  async previousStep() {
    if (this.form.steps.length > 0) {
      this.animation = "slide-right";
      if (this.currentStepIndex > 0) {
        this.currentStepIndex--;
        this.currentStep = this.form.steps[this.currentStepIndex];
        if (!this.currentStep!.isVisible()) {
          this.previousStep();
        }
      }
    }
    await this.updateStepRank(this.currentStep.uuid);
    await this.updateState();
  }

  async nextStep() {
    const cs: Step = this.currentStep as any;
    cs.validate();
    let nextIndex = this.currentStepIndex + 1;
    if (cs.isValid) {
      // Attendre que les sauvegardes en cours se terminent avant de naviguer
      if (api.sendingResponses) {
        const start = new window.Date().getTime();
        while (
          api.sendingResponses &&
          new window.Date().getTime() - start < 3000
        ) {
          await new Promise((resolve) => setTimeout(resolve, 100));
        }
      }
      this.animation = "slide-left";
      if (this.form.steps.length > nextIndex) {
        this.currentStepIndex = nextIndex;
        this.currentStep = this.form.steps[nextIndex];
        if (!this.currentStep.isVisible()) {
          this.nextStep();
        } else {
          this.currentStep.validate();
        }
      }
    }
    await this.updateStepRank(this.currentStep.uuid);
    await this.updateState();
  }

  async updateStepRank(uuid: string) {
    // if (!api.sendingResponses) {
    const res = await api.get(
      api.form,
      "api/update/current/rank/" + this.rg.uuid + "/" + uuid
    );
    // }
  }

  async lastStep() {
    let found = false;
    for (let [index, step] of this.form.steps.entries()) {
      let accessGranted = true;
      if (!helper.empty(step.requiredRoles)) {
        accessGranted = auth.checkRoleTabs(step.requiredRoles);
        if (!accessGranted) {
          continue;
        }
      }
      step.validate();
      if (!step.isValid || step.ranking >= this.rg.currentStepRank) {
        found = true;
        this.currentStepIndex = index;
        this.currentStep = this.form.steps[this.currentStepIndex];
        return;
      }
    }
    this.currentStepIndex = 0;
    this.currentStep = this.form.steps[0];
  }

  isSectionContainSurvey(section: Section) {
    let found = false;
    section.questions.forEach((q: Question) => {
      if (q.type.code.match(/OBJECT|OBJECT_GROUP/)) {
        found = true;
        return found;
      }
    });
    return found;
  }

  async loadNewData() {
    this.$store.commit("loading");

    if (!this.rg || !this.form) {
      this.requireAuth = false;
      this.notFound = false;

      try {
        // 1. Charger les données depuis formStore (sync + RG)
        const result = await this.$store.dispatch("formStore/loadResponseGroupData", this.rgUuid);
        if (!result.success) {
          console.error("Failed to load data:", result.error);
          this.notFound = true;
          this.$store.commit("stopLoading");
          return;
        }

        // 2. Reconstruire les entités depuis le store plat
        let surveyData = this.$store.getters["formStore/getSurveyFull"](result.surveySlug);
        const rgData = this.$store.getters["formStore/getResponseGroup"](result.rgUuid);
        // Si le survey du RG n'est pas en store (ex: sous-survey non remonte par
        // le delta sync), on charge sa structure ciblee et on retente.
        if (!surveyData && result.surveySlug) {
          await this.$store.dispatch("formStore/loadSurveyStructure", result.surveySlug);
          surveyData = this.$store.getters["formStore/getSurveyFull"](result.surveySlug);
        }
        if (!surveyData || !rgData) {
          this.notFound = true;
          this.$store.commit("stopLoading");
          return;
        }

        this.form = new Survey(surveyData);
        this.rg = new ResponseGroup(rgData);
        this.rg.survey = this.form;

        // 3. Charger les données de la branche (insurers, etc.) depuis coreStore/comparatorStore
        if (result.branchSlug) {
          {
            const branchRes = await api.get(api.core, "api/get/comparator/data/" + result.branchSlug);
            if (branchRes && branchRes.data) {
              // Reconstituer la branche avec ses itemTypes et packCategories
              const fullBranch = {
                ...branchRes.data.branch,
                items: branchRes.data.itemTypes ? Object.values(branchRes.data.itemTypes) : [],
                packCategories: branchRes.data.packCategories ? Object.values(branchRes.data.packCategories) : [],
                packs: branchRes.data.packs ? Object.values(branchRes.data.packs) : [],
                guarantees: branchRes.data.guarantees ? Object.values(branchRes.data.guarantees) : [],
                premiumDetailModels: branchRes.data.premiumDetailModels ? Object.values(branchRes.data.premiumDetailModels) : [],
                reductionModels: branchRes.data.reductionModels ? Object.values(branchRes.data.reductionModels) : [],
              };
              this.$store.commit("comparatorStore/ADD_DATA", {
                property: "branches",
                key: result.branchSlug,
                value: fullBranch,
              });
              // Résoudre les guarantee IDs dans les packGuarantees des packs
              const allGuarantees = branchRes.data.guarantees || {};
              const allPacks = branchRes.data.packs || {};
              Object.values(allPacks).forEach((pack: any) => {
                if (pack.packGuarantees) {
                  pack.packGuarantees = pack.packGuarantees.map((pg: any) => {
                    if (pg.guarantee && typeof pg.guarantee === 'number') {
                      pg.guarantee = allGuarantees[pg.guarantee] || { id: pg.guarantee };
                    }
                    return pg;
                  });
                }
              });
              if (branchRes.data.insurers) {
                const insurersArray = Array.isArray(branchRes.data.insurers)
                  ? branchRes.data.insurers
                  : Object.values(branchRes.data.insurers);
                insurersArray.forEach((insurer: any) => {
                  // Résoudre les IDs de packs en objets complets
                  if (insurer.packs && Array.isArray(insurer.packs)) {
                    insurer.packs = insurer.packs
                      .map((packId: any) => typeof packId === 'object' ? packId : allPacks[packId])
                      .filter(Boolean);
                  }
                  this.$store.commit("comparatorStore/ADD_DATA", {
                    property: "insurers",
                    key: insurer.slug || insurer.id,
                    value: insurer,
                  });
                });
              }
              this.branch = new Branch(fullBranch);
            }
          }
        }

        // 4. Charger le moteur de calcul
        if (this.branch && this.branch.slug) {
          await this.loadEngine();
        }

        // 5. Stocker les insurers dans mainStore pour compatibilité
        const insurers = Object.values(this.$store.state.comparatorStore.insurers || {});
        if (insurers.length > 0) {
          this.$store.commit("setInsurers", insurers.map((i: any) => new Insurer(i)));
        }

        // 6. Enregistrer survey et RG dans mainStore
        this.$store.commit("appendSurvey", this.form);
        this.$store.commit("appendRg", this.rg);

        // 7. Charger les réponses du RG dans formStore puis mapper aux questions
        if (this.rg.responses && this.rg.uuid) {
          this.$store.commit("formStore/LOAD_RESPONSES", {
            rgUuid: this.rg.uuid,
            responses: this.rg.responses,
          });
        }
        this.linkResponsesToStore();

        // 8. Activer le contexte APRES que tout soit prêt (déclenche les watchers)
        if (!this.melted) {
          this.$store.commit("setCurrentContext", {
            responseGroup: this.rg,
            survey: this.form,
            branch: this.branch,
          });
        }

        // Notifier le store que les responses sont chargees pour declencher la reactivite
        this.$nextTick(() => {
          this.$store.commit("responseSaved");
        });

        // Extraire les sous-responseGroups
        this.extractRgs(this.rg);

        // Configurer les packCategories si disponibles
        if (this.branch && this.branch.packCategories) {
          store.commit("formStore/SET_PACK_CATEGORIES", this.branch.packCategories);
        }

        // Aller à la dernière étape complétée
        if (this.form.steps.length > 0) {
          this.lastStep();
        }

        // Mettre à jour l'état de progression
        await this.updateState();
      } catch (error) {
        console.error("Error loading data:", error);
        this.notFound = true;
      }
    }

    this.$store.commit("stopLoading");
  }

  // Lier chaque question directement à son entrée FormStore (source unique de vérité)
  linkResponsesToStore() {
    const prefillData = prefillService.getStoredPrefillData();
    const hasPrefillData = Object.keys(prefillData).length > 0;

    if (!this.form || !this.rg) return;

    const storeResponses = this.$store.state.formStore.responses[this.rg.uuid] || {};

    if (this.form.steps && this.form.steps.length > 0) {
      this.form.steps.forEach((s: Step) => {
        s.sections.forEach((sec: Section) => {
          sec.questions.forEach((q: Question) => {
            let entry = storeResponses[String(q.id)] || null;

            if (!entry) {
              // Créer une entrée vide dans le FormStore
              this.$store.commit("formStore/SET_RESPONSE_VALUE", {
                rgUuid: this.rg.uuid,
                questionId: String(q.id),
                value: undefined,
              });
              entry = this.$store.state.formStore.responses[this.rg.uuid][String(q.id)];
              Vue.set(entry, "questionUuid", q.uuid);
            }

            // Appliquer la defaultValue si l'entrée n'a pas de valeur ET que la question est visible.
            // Sans ce garde-fou, une question masquée par condition (ex: usage véhicule
            // particulier alors qu'on a sélectionné moto) pousserait son default au backend.
            if (!helper.empty(q.defaultValue) && helper.empty(entry.value) && (typeof q.isVisible !== 'function' || q.isVisible())) {
              // Pour les Radio/select, vérifier que la defaultValue correspond à un choix existant
              const isChoiceType = q.type && q.type.code && q.type.code.match(/RADIO|DURATION/);
              const defaultValid = !isChoiceType
                || !q.choices
                || q.choices.length === 0
                || q.choices.some((c: any) => c.code === q.defaultValue);

              if (defaultValid) {
                Vue.set(entry, "value", q.defaultValue);
                Vue.set(entry, "currentValue", q.defaultValue);
                Vue.set(entry, "synced", false);
                this.$store.commit("formStore/ADD_PENDING_SYNC", {
                  rgUuid: this.rg.uuid,
                  questionId: String(q.id),
                });
              }
            }

            // Enrichir l'entrée avec les refs nécessaires aux composants
            if (!entry.questionUuid) {
              Vue.set(entry, "questionUuid", q.uuid);
            }
            if (!entry.responseGroupUuid) {
              Vue.set(entry, "responseGroupUuid", this.rg.uuid);
            }

            // question.response pointe directement sur l'entrée FormStore
            // → v-model lit/écrit le store, plus de copie
            q.response = entry;

            // Ajouter au RG si pas déjà présent
            if (!this.rg.responses) this.rg.responses = [];
            const existIdx = this.rg.responses.findIndex((r: any) =>
              r.questionUuid === q.uuid || r.question?.id === q.id
            );
            if (existIdx === -1) {
              this.rg.responses.push(entry);
            } else {
              this.rg.responses[existIdx] = entry;
            }

            // Gérer les sous-surveys
            if (q.type && q.type.code && q.type.code.includes("OBJECT")) {
              this.$store.commit("appendSurvey", q.survey);
            }

            q.validate();

            // Appliquer le préremplissage si disponible
            if (hasPrefillData && q.uuid && prefillData[q.uuid]) {
              const prefillValue = prefillData[q.uuid];
              if (!entry.value || entry.value === "") {
                Vue.set(entry, "value", prefillValue);
                q.validate();
                q.updateAnswer();
              }
            }
          });
        });
      });
    }

    if (hasPrefillData) {
      prefillService.clearPrefillData();
      this.$store.commit("responseSaved");
    }

    // Flush les defaultValues en attente vers le serveur
    if (Object.keys(this.$store.state.formStore.pendingSync).length > 0) {
      this.$store.dispatch("formStore/scheduleFlush");
    }
  }

  async loadBranchData(slug: string, partner: any) {
    let endpoint = "api/get/comparator/data/" + slug;
    if (partner) {
      endpoint += "/" + partner;
    }
    const res = await api.get(api.core, endpoint);
  }

  updated() {
  }

  async loadEngine() {
    await api.loadWorkerEngine(this.branch.slug);
    // await api.loadEngine(this.branch.slug);
    // this.$store.commit('responseSaved')
    // this.compare()
    // this.$store.state.mainStore.engineClasses = window['classes' as any]
  }

  executeIfFileExist(src: any, callback: any, reject: any = null) {
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (this.status === 0 && reject) {
        reject();
      }
      if (this.readyState === this.DONE) {
        callback();
      }
    };
    xhr.open("GET", src);
  }

  async deleteSubResponseGroup(payload: any) {
    if (payload.rg) {
      this.creatingResponseGroup = true;
      const pop = new Popup(
        "Chargement",
        "Suppression en cours",
        "warning",
        "fad fa-cogs",
        true
      );
      const res = await api.get(
        api.form,
        "api/delete/sub/response/group/" +
          payload.rg.uuid +
          "/" +
          payload.question.response.uuid
      );
      this.creatingResponseGroup = false;
      if (res && res.data && res.data.status === "success") {
        // 1) Retrait reactif via formStore (source de verite cote store).
        this.$store.commit("formStore/REMOVE_SUB_RG", {
          rgUuid: this.rg.uuid,
          questionId: payload.question.id,
          subRgUuid: payload.rg.uuid,
        });
        // 2) Backup: retrait direct sur la liste pointee par question.response
        //    au cas ou la reactivite ne se propage pas jusqu'au template (prop
        //    dynamique non observee par Vue sur l'instance Question).
        const list = payload.question?.response?.responseGroups;
        if (Array.isArray(list)) {
          const idx = list.findIndex((r: any) => r && r.uuid === payload.rg.uuid);
          if (idx !== -1) list.splice(idx, 1);
        }
        this.$store.commit("deleteSubResponseGroup", payload.rg.uuid);
        payload.question.updateAnswer();
        this.$store.commit("responseSaved");
        this.$forceUpdate();
      }
      pop.hide();
    } else {
      this.deleteSubResponseGroups(payload);
    }
  }

  async deleteSubResponseGroups(payload: any) {
    const data = {
      questionUuid: payload.question.uuid,
      rgUuids: [] as string[],
    };
    payload.rgs.forEach((rg: ResponseGroup) => {
      data.rgUuids.push(rg.uuid);
    });
    this.$store.commit("loading");
    const pop = new Popup(
      "Chargement",
      "Suppression en cours",
      "warning",
      "fad fa-cogs",
      true
    );
    const res = await api.post(
      api.form,
      "api/delete/sub/response/groups",
      data
    );
    this.$store.commit("stopLoading");
    if (res && res.data && res.data.status === "success") {
      const list = payload.question?.response?.responseGroups;
      res.data.deleted.forEach((d: any) => {
        this.$store.commit("formStore/REMOVE_SUB_RG", {
          rgUuid: this.rg.uuid,
          questionId: payload.question.id,
          subRgUuid: d,
        });
        if (Array.isArray(list)) {
          const idx = list.findIndex((r: any) => r && r.uuid === d);
          if (idx !== -1) list.splice(idx, 1);
        }
        this.$store.commit("deleteSubResponseGroup", d);
        payload.question.updateAnswer();
      });
      this.$store.commit("responseSaved");
      this.$forceUpdate();
    }
    pop.hide();
  }

  @Watch("$store.state.mainStore.rgStatus")
  async handleResponse() {
    this.debouncedValidate();
  }

  @Watch("$store.state.mainStore.stepStatus")
  async checkStepStatus() {
    this.debouncedValidate();
  }

  private debouncedValidate() {
    if (this._validateTimer) {
      clearTimeout(this._validateTimer);
    }
    this._validateTimer = setTimeout(() => {
      // Purger les réponses des questions devenues cachées (en dehors du cycle de rendu)
      if (this.form) {
        this.form.getQuestions().forEach((q: Question) => {
          q.clearIfHidden();
        });
      }
      this.updateState();
      if (this.currentStep) {
        this.currentStep.validate();
      }
      this.isCurrentStepFinished();
    }, 150);
  }

  async updateState() {
    if (this.rg && this.form) {
      // Mode étape-par-étape : on plafonne le % à l'étape courante (progression réelle).
      // Mode ROLE_MANAGER : toutes les étapes sont affichées sur une seule page (remplissage
      // rapide) -> currentStepIndex ne reflète pas la progression, on ne plafonne pas sinon
      // le % est tronqué (ex: 15% au lieu du vrai).
      const maxStep = this.isManager() ? null : this.currentStepIndex;
      const details = this.rg.getStateDetails(null, maxStep);

      if (!details) return;

      const index = this.form.slug + "_" + this.rg.uuid;
      if (!details[index]) return;

      let state = details[index]["percent"];
      let step = 1;
      if (this.progress > state) {
        step = -1;
      }
      let max = 0;
      let min = 0;
      let count = 0;
      this.progress = state;
    }
  }

  isCurrentStepFinished() {
    const currentStep: Step = this.currentStep;
    if (!currentStep) {
      return;
    }
    currentStep.validate();
    if (currentStep.isValid) {
      // this.nextStep()
    }
    // this.$forceUpdate()
  }

  extractRgs(rg: ResponseGroup) {
    rg.responses?.forEach((res: Response) => {
      res.responseGroups.forEach((r: ResponseGroup) => {
        const rgOcc = new ResponseGroup(r);
        this.$store.commit("appendRg", rgOcc);
        this.extractRgs(rgOcc);
      });
    });
  }

  extractSurveys(survey: Survey) {
    this.$store.commit("appendSurvey", survey);
    survey.steps.forEach((step: Step) => {
      step.sections.forEach((section: Section) => {
        section.questions.forEach((question: Question) => {
          if (question.survey) {
            this.extractSurveys(question.survey);
          }
        });
      });
    });
    // rg.responses.forEach((res: Response) => {
    //   res.responseGroups.forEach((r: ResponseGroup) => {
    //     const rgOcc = new ResponseGroup(r)
    //     this.$store.commit('appendRg', rgOcc)
    //     this.extractRgs(rgOcc)
    //   })
    // })
  }
}
</script>

<style scoped>
.page {
  max-width: 100%;
}

.row {
  max-width: 1200px;
}

/*@media only screen and (max-width: 992px) {*/
/*    .wizard {*/
/*        display: none;*/
/*    }*/

/*    .question-container-card {*/
/*        width: 100%*/
/*    }*/

/*}*/
.text-green {
  color: #3ddad7;
}

.progress {
  overflow: visible;
}

.progress-percent {
  bottom: 5px;
  position: absolute;
  right: 0;
}

/deep/ input:not[type="checkbox"] {
  padding: 0.8rem 2rem;
}

/deep/ select {
  padding: 0.8rem 1rem;
}

.progress {
  height: 4px;
  /*margin-bottom: 2rem;*/
  background-color: #dce7e8;
}

.progress .determinate {
  background-color: #3ddad7;
  transition: all 0.5s ease;
}

.wizard-step.active,
.wizard-step.active i,
.wizard-step.active .wizard-title {
  color: #3ddad7 !important;
}

/*///////////////////////////////////////////////*/
.max-width {
  transform-origin: left center;
}

.max-width-enter-active,
.max-width-leave-active {
  transition: all 1s;
  transform: scaleX(1);
}

.max-width-leave-from {
  transition: all 1s;
}

.max-width-enter {
  opacity: 0;
  transform: scaleX(0);
}

.max-width-leave-to {
  opacity: 0;
  transform: scaleX(1);
}

/*/////////////////////////////////////////////////////*/
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all calc(var(--i) * 0.2s);
}

.slide-up-leave-from,
.slide-up-leave-from {
  transition: all 0s;
}

.slide-up-enter {
  opacity: 0;
  transform: translateY(50%);
}

/*/////////////////////////////////////////////////////*/
.slide-up2-enter-active,
.slide-up2-leave-active {
  transition: all calc(var(--i) * 0.2s);
}

.slide-up2-leave-from,
.slide-up2-leave-from {
  transition: all calc(var(--i) * 0.2s);
}

.slide-up2-enter {
  opacity: 0;
  transform: translateY(100%);
}

@media only screen and (max-width: 992px) {
  .wizard {
    display: none;
  }

  .question-container-card {
    width: 100%;
  }
}
</style>
